Namespace 'Customer.Dashboard'

class Customer.Dashboard.UserContact extends Backbone.Model
  defaults:
    name: undefined
    email: undefined
    score: undefined


class Customer.Dashboard.UserContactCollection extends Backbone.Collection
  model: Customer.Dashboard.UserContact

  fetchSuggestions: ({searchQuery}) ->
    @reset()
    return @trigger('fetched:suggestions') unless searchQuery
    @fetch
      type: 'GET'
      url: '/customer/dashboard/suggest_contacts'
      data:
        search_query: searchQuery
      success: => @trigger('fetched:suggestions')
